import { newIdempotencyKey } from "./onlinePayment";

// sessionStorage de propósito: a chave sobrevive a um F5, mas não ao fim da sessão.
// No localStorage, um cliente que voltasse dias depois com o mesmo carrinho
// receberia o pedido antigo (a chave não expira no servidor) em vez de um novo.
const STORAGE_KEY = "pedido.checkoutAttempt";

const read = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return null;
  }
};

/** Mesmo payload reaproveita a chave; carrinho ou dados alterados geram outra. */
export const getCheckoutKey = (payload) => {
  const attempt = read();
  if (attempt?.payload === payload && attempt?.key) return attempt.key;

  const key = newIdempotencyKey();
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ key, payload }));
  } catch (e) {
    // sem storage a chave ainda protege contra repetições enquanto esta chamada durar
  }
  return key;
};

export const clearCheckoutKey = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // nada a limpar
  }
};
